@if (action == 'create') {
  <div class="container">
    <h1 class="fs-2 fw-light mt-4">Add Payment</h1>
    <form [formGroup]="addPaymentForm" >
      <!-- <div class="form-group my-4">
      <label class="form-label" for="firstname">Period</label>
      <input class="form-control col-3"  type="text" placeholder="Period" formControlName="period" [ngClass]="{ 'is-invalid': submitPaymentData && poa.period.errors, 'is-valid': poa.period.valid && poa.period.touched }"/>
    </div> -->
    <div class="form-group my-4">
      <label class="form-label" for="firstname">Payment Amount</label>
      <input class="form-control col-3"  type="text" placeholder="Amount e.g 1200" formControlName="amount" [ngClass]="{ 'is-invalid': submitPaymentData && poa.amount.errors, 'is-valid': poa.amount.valid && poa.amount.touched }"/>
      <!-- <span class="invalid-feedback" *ngIf="submitPaymentData && poa.amount.errors!.min!">Payment amount has to be at lease $1</span> -->
    </div>
    <div class="form-group my-4">
      <label>Choose {{obligationCategoryConfig.maintenanceActionLabel}} Period for Payment <span class="fw-bold">{{totalselected | currency}}</span></label>
    </div>
    @for (outstanding of outstandingMaintenance | orderBy: 'period'; track outstanding) {
      <div class="my-1 alert-info alert mx-1 " >
        <p class="d-block">
          <input class="form-check-input" type="checkbox" id="pcheck{{outstanding.id}}" value="{{outstanding.id}}" (change)="onCheckboxChange($event, outstanding.id)">
          {{ outstanding.period | date: 'MMM-y':'UTC'}} <sup class="fw-bold">{{getOutstandingTypeLabel(outstanding)}}</sup>
        </p>
        <p class="d-block mt-2">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ outstanding.amount | currency }}
        </p>
      </div>
    }
    <div class="form-group my-4"  >
      <mat-form-field appearance="outline" [class.mat-form-field-invalid]="false">
        <mat-label>Choose Payment Date</mat-label>
        <input matInput [matDatepicker]="picker" formControlName="period_date"  >
        @if (submitPaymentData && poa['period_date'].errors) {
          <mat-error>Please choose payment date</mat-error>
        }
        <mat-hint>MM/DD/YYYY</mat-hint>
        <mat-datepicker-toggle matSuffix [for]="picker">
        </mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="form-group my-4">
      <mat-form-field appearance="outline">
        <mat-label>Choose Effective Date</mat-label>
        <input matInput [matDatepicker]="picker1" formControlName="effective_date" >
        <mat-hint>MM/DD/YYYY</mat-hint>
        @if (submitPaymentData && poa.effective_date.errors) {
          <mat-error>Please choose effective payment date</mat-error>
        }
        <mat-datepicker-toggle matSuffix [for]="picker1">
        </mat-datepicker-toggle>
        <mat-datepicker #picker1></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="form-group my-4">
      <label class="form-label" for="firstname">Paid By</label>
      <input class="form-control col-3"  type="text" placeholder="Paid by e.g John Brown" formControlName="paid_by" [ngClass]="{ 'is-invalid': submitPaymentData && poa.paid_by.errors, 'is-valid': poa.paid_by.valid && poa.paid_by.touched }"/>
    </div>
    <div class="form-group">
      <label class="form-label">Payment Method</label>
      <select class="form-select form-control" formControlName="payment_method" [ngClass]="{ 'is-invalid': submitPaymentData && poa.payment_method.errors, 'is-valid': poa.payment_method.valid && poa.payment_method.touched }">
        <option value="1">Cash</option>
        <option value="2">Credit Card</option>
        <option value="3">Bank Transfer</option>
      </select>
    </div>
    <div class="form-group my-4">
      <label class="form-label" for="description">Description</label>
      <input class="form-control col-3"  type="text" [placeholder]="paymentDescriptionPrefix + ' Period'" formControlName="description"  />
    </div>
    <div class="form-group my-4">
      <label class="form-label" for="firstname">Lot/Unit Number</label>
      <input class="form-control col-3"  type="text" placeholder="Lot/Unit number" formControlName="unitNumber" [ngClass]="{ 'is-invalid': submitPaymentData && poa.premiseId.errors, 'is-valid': poa.premiseId.valid && poa.premiseId.touched }" readonly/>
      <input class="form-control col-3"  type="hidden" formControlName="premiseId" readonly/>
    </div>
    <div class="form-group my-4">
      <label class="form-label" for="property">Property</label>
      <input class="form-control col-3"  type="text" placeholder="Property" formControlName="propertyName" [ngClass]="{ 'is-invalid': submitPaymentData && poa.premiseId.errors, 'is-valid': poa.premiseId.valid && poa.premiseId.touched }" readonly/>
    </div>

    <div class="form-group my-4">
      <label class="form-label">Attachment (optional)</label>
      <input class="form-control col-3" type="file" accept=".pdf,.jpeg,.jpg,.png,image/jpeg,image/jpg,image/png,application/pdf" (change)="onAttachmentSelected($event, 'create')" />
      <small class="text-muted d-block mt-1">Allowed: PDF, JPEG, JPG, PNG. Max size: 5 MB.</small>
      @if (selectedCreateAttachmentName) {
        <div class="d-flex align-items-center gap-2 mt-2">
          <span>{{ selectedCreateAttachmentName }}</span>
          <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearSelectedAttachment('create')">Clear</button>
        </div>
      }
    </div>
  </form>
</div>
}
@if (action == 'edit') {
  <div class="container">
    <h1 class="fs-2 fw-light mt-4">Edit Payment</h1>
    <form [formGroup]="editPaymentForm" >
      <!-- <div class="form-group my-4">
      <label class="form-label" for="firstname">Period</label>
      <input class="form-control col-3"  type="text" placeholder="Period" formControlName="period" [ngClass]="{ 'is-invalid': submitPaymentData && poa.period.errors, 'is-valid': poa.period.valid && poa.period.touched }"/>
    </div> -->
    <div class="form-group my-4">
      <label class="form-label" for="firstname">Amount</label>
      <input class="form-control col-3"  type="text" placeholder="Amount e.g 1200" formControlName="amount" [ngClass]="{ 'is-invalid': submitPaymentData && poa.amount.errors, 'is-valid': poa.amount.valid && poa.amount.touched }"/>
    </div>
    <div class="form-group my-4">
      <label>Choose {{obligationCategoryConfig.maintenanceActionLabel}} Period for Payment</label>
      <!-- <p>Show last 12 months as checkbox items</p> -->
    </div>
    <div class="row">
      @for (outstanding of outstandingMaintenance; track outstanding) {
        <div class="my-1 alert-info alert mx-1 d-inline mx-2" >
          <input class="form-check-input" type="checkbox" id="pcheck{{outstanding.id}}" value="{{outstanding.id}}" (change)="onCheckboxChange($event, outstanding.id)">
          {{ outstanding.period | date: 'MMM-y':'UTC'}}
        </div>
      }
    </div>
    <!-- <span class="my-1 alert-info alert mx-1 special-span" *ngFor="let outstanding of outstandingMaintenance" >
    <input class="form-check-input" type="checkbox" id="pcheck{{outstanding.id}}" value="{{outstanding.id}}" (change)="onCheckboxChange($event, outstanding.id)">
    {{ outstanding.period | date: 'MMM-y':'UTC'}}
  </span> -->
  <div class="form-group my-4">
    <mat-form-field appearance="fill">
      <mat-label>Choose Payment Date</mat-label>
      <input matInput [matDatepicker]="picker" formControlName="period_date"  >
      <mat-hint>MM/DD/YYYY</mat-hint>
      <mat-datepicker-toggle matSuffix [for]="picker">
      </mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  </div>
  <div class="form-group my-4">
    <mat-form-field appearance="fill">
      <mat-label>Choose Effective Date</mat-label>
      <input matInput [matDatepicker]="picker1" formControlName="effective_date" >
      <mat-hint>MM/DD/YYYY</mat-hint>
      <mat-datepicker-toggle matSuffix [for]="picker1">
      </mat-datepicker-toggle>
      <mat-datepicker #picker1></mat-datepicker>
    </mat-form-field>
  </div>
  <div class="form-group my-4">
    <label class="form-label" for="description">Description</label>
    <input class="form-control col-3"  type="text" [placeholder]="paymentDescriptionPrefix + ' Period'" formControlName="description"  />
  </div>
  <div class="form-group my-4">
    <label class="form-label" for="firstname">Paid By</label>
    <input class="form-control col-3"  type="text" placeholder="Paid by e.g John Brown" formControlName="paid_by" [ngClass]="{ 'is-invalid': submitPaymentData && poa.paid_by.errors, 'is-valid': poa.paid_by.valid && poa.paid_by.touched }"/>
  </div>
  <div class="form-group">
    <label class="form-label">Payment Method</label>
    <select class="form-select form-control" formControlName="payment_method">
      <option value="1">Cash</option>
      <option value="2">Credit Card</option>
      <option value="3">Bank Transfer</option>
    </select>
  </div>
  <div class="form-group my-4">
    <label class="form-label" for="firstname">Lot/Unit Number</label>
    <input class="form-control col-3"  type="text" placeholder="Lot/Unit number" formControlName="unitNumber" [ngClass]="{ 'is-invalid': submitPaymentData && poa.premiseId.errors, 'is-valid': poa.premiseId.valid && poa.premiseId.touched }" readonly/>
    <input class="form-control col-3"  type="hidden" formControlName="premiseId" readonly/>
  </div>
  <div class="form-group my-4">
    <label class="form-label" for="property">Property</label>
    <input class="form-control col-3"  type="text" placeholder="Property" formControlName="propertyName" [ngClass]="{ 'is-invalid': submitPaymentData && poa.premiseId.errors, 'is-valid': poa.premiseId.valid && poa.premiseId.touched }" readonly/>
  </div>

  <div class="form-group my-4">
    <label class="form-label">Replace/Add Attachment (optional)</label>
    <input class="form-control col-3" type="file" accept=".pdf,.jpeg,.jpg,.png,image/jpeg,image/jpg,image/png,application/pdf" (change)="onAttachmentSelected($event, 'edit')" />
    <small class="text-muted d-block mt-1">Allowed: PDF, JPEG, JPG, PNG. Max size: 5 MB.</small>
    @if (selectedEditAttachmentName) {
      <div class="d-flex align-items-center gap-2 mt-2">
        <span>{{ selectedEditAttachmentName }}</span>
        <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearSelectedAttachment('edit')">Clear</button>
      </div>
    }
  </div>

  <div class="form-group my-4">
    <label class="form-label">Existing Attachments</label>
    @if (loadingAttachments) {
      <div class="text-muted">Loading attachments...</div>
    }
    @if (!loadingAttachments && attachments.length === 0) {
      <div class="text-muted">No attachments found for this payment.</div>
    }
    @if (!loadingAttachments && attachments.length > 0) {
      @for (attachment of attachments; track attachment.id) {
        <div class="alert alert-secondary d-flex justify-content-between align-items-center py-2 px-3 mb-2">
          <div>
            <div class="fw-semibold">{{ attachment.file_name }}</div>
            <small class="text-muted">{{ attachment.mime_type }} | {{ attachment.file_size / (1024 * 1024) | number:'1.2-2' }} MB</small>
          </div>
          <div class="d-flex gap-2">
            <button type="button" class="btn btn-sm btn-outline-primary" (click)="viewAttachment(attachment)">View</button>
            <button type="button" class="btn btn-sm btn-outline-danger" (click)="removeAttachment(attachment.id)">Remove</button>
          </div>
        </div>
      }
    }
  </div>
</form>
</div>
}
@if (action == 'view') {
  <div class="container">
    <div class="d-flex justify-content-between align-items-center">
      <h1 class="fs-2 fw-light mt-4">View Payment</h1>
      <button (click)="onEditPayment()" class="mt-4 btn btn-primary">Edit <fa-icon [icon]="faPenToSquare"></fa-icon></button>
    </div>
    <form [formGroup]="viewPaymentForm" >
      <!-- <div class="form-group my-4">
      <label class="form-label" for="firstname">Period</label>
      <input class="form-control col-3"  type="text" placeholder="Period" formControlName="period" [ngClass]="{ 'is-invalid': submitPaymentData && poa.period.errors, 'is-valid': poa.period.valid && poa.period.touched }"/>
    </div> -->
    <div class="form-group my-4">
      <label class="form-label" for="firstname">Amount</label>
      <input class="form-control col-3"  type="text" placeholder="Amount e.g 1200" formControlName="amount" [ngClass]="{ 'is-invalid': submitPaymentData && poa.amount.errors, 'is-valid': poa.amount.valid && poa.amount.touched }"/>
    </div>
    <div class="form-group my-4">
      <label>{{obligationCategoryConfig.maintenanceActionLabel}} Period(s) paid with this Payment</label>
      <!-- <p>Show last 12 months as checkbox items</p> -->
      @for (period of payment.payment_obligations; track period) {
        <div class="alert alert-info mx-2">
          <span class="d-block">
            {{ period.obligationperiod | date: 'MMM-y':'UTC' | orderBy: 'obligationperiod' : sortOrder}}
          </span>
          <span class="d-block">
            {{ period.amount | currency }}
          </span>
        </div>
      }
    </div>
    @for (outstanding of outstandingMaintenance; track outstanding) {
      <span class="my-1 alert-info alert mx-1" >
        <input class="form-check-input" type="checkbox" id="pcheck{{outstanding.id}}" value="{{outstanding.id}}" (change)="onCheckboxChange($event,outstanding.id)">
        {{ outstanding.period | date: 'MMM-y':'UTC'}}
      </span>
    }
    <div class="form-group my-4">
      <label class="form-label" for="description">Description</label>
      <input class="form-control col-3"  type="text" [placeholder]="paymentDescriptionPrefix + ' Period'" formControlName="description"  />
    </div>
    <div class="form-group my-4">
      <label class="form-label" for="period_date">Payment Date</label>
      <input class="form-control col-3"  type="text" placeholder="January-1-2020" formControlName="period_date"  />
    </div>
    <div class="form-group my-4">
      <label class="form-label" for="effective_date">Effective Date</label>
      <input class="form-control col-3"  type="text" placeholder="January-1-2020" formControlName="effective_date"  />
    </div>
    <div class="form-group my-4">
      <label class="form-label" for="firstname">Paid By</label>
      <input class="form-control col-3"  type="text" placeholder="Paid by e.g John Brown" formControlName="paid_by" [ngClass]="{ 'is-invalid': submitPaymentData && poa.paid_by.errors, 'is-valid': poa.paid_by.valid && poa.paid_by.touched }"/>
    </div>
    <div class="form-group">
      <label class="form-label">Payment Method</label>
      <select class="form-select form-control" formControlName="payment_method">
        <option value="1">Cash </option>
        <option value="2">Credit Card </option>
        <option value="3">Bank Transfer </option>
      </select>
    </div>
    <div class="form-group my-4">
      <label class="form-label" for="firstname">Lot/Unit Number</label>
      <input class="form-control col-3"  type="text" placeholder="Lot/Unit number" formControlName="unitNumber" [ngClass]="{ 'is-invalid': submitPaymentData && poa.premiseId.errors, 'is-valid': poa.premiseId.valid && poa.premiseId.touched }" readonly/>
      <input class="form-control col-3"  type="hidden" formControlName="premiseId" readonly/>
    </div>
    <div class="form-group my-4">
      <label class="form-label" for="property">Property</label>
      <input class="form-control col-3"  type="text" placeholder="Property" formControlName="propertyName" [ngClass]="{ 'is-invalid': submitPaymentData && poa.premiseId.errors, 'is-valid': poa.premiseId.valid && poa.premiseId.touched }" readonly/>
    </div>

    <div class="form-group my-4">
      <label class="form-label">Attachments</label>
      @if (loadingAttachments) {
        <div class="text-muted">Loading attachments...</div>
      }
      @if (!loadingAttachments && attachments.length === 0) {
        <div class="text-muted">No attachments found for this payment.</div>
      }
      @if (!loadingAttachments && attachments.length > 0) {
        @for (attachment of attachments; track attachment.id) {
          <div class="alert alert-secondary d-flex justify-content-between align-items-center py-2 px-3 mb-2">
            <div>
              <div class="fw-semibold">{{ attachment.file_name }}</div>
              <small class="text-muted">{{ attachment.mime_type }} | {{ attachment.file_size / (1024 * 1024) | number:'1.2-2' }} MB</small>
            </div>
            <button type="button" class="btn btn-sm btn-outline-primary" (click)="viewAttachment(attachment)">View</button>
          </div>
        }
      }
    </div>
  </form>
</div>
}
@if (action == 'list') {
  <div class="container">
    <h1 class="fs-2 fw-light mt-4">List Payments</h1>
  </div>
}
<div class="mt-4 d-flex container justify-content-between align-items-center">
  <button (click)="goBack()" class="btn btn-primary"><fa-icon [icon]="faCircleArrowLeft"></fa-icon> Back</button>

  @if (action == 'create') {
    <button [disabled]="fetching" class="btn btn-primary" (click)="createPayment()" >
      Save @if (!fetching) {
      <fa-icon [icon]="faPaperPlane"></fa-icon>
    }
    @if (fetching) {
      <span class="spinner-border spinner-border-sm mr-1"></span>
    }
  </button>
}

@if (action == 'edit') {
  <button [disabled]="fetching" class="btn btn-info" (click)="updatePayment()">
    Update @if (!fetching) {
    <fa-icon [icon]="faPaperPlane"></fa-icon>
  }
  @if (fetching) {
    <span class="spinner-border spinner-border-sm mr-1"></span>
  }
</button>
}
</div>
